var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 909.29 310.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#fff;}.cls-3{fill:#0c0c0c;}.cls-4{opacity:.03;}.cls-5{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.97,
    width: 908.32,
    height: 310.76,
    rx: 8.58,
    ry: 8.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 0,
    width: 908.32,
    height: 310.76,
    rx: 8.58,
    ry: 8.58
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.36,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.03,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.62,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.29,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m95.88,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.55,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.14,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.81,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m168.4,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m164.07,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m204.66,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.33,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m240.92,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m236.6,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m277.19,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m272.86,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m313.45,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m309.12,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m349.71,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m345.38,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m385.97,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m381.64,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m422.23,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m417.9,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m458.49,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m454.16,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.64,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.32,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.91,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.58,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.17,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.84,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.43,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.1,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m150.69,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m146.36,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.95,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m182.62,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.21,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.88,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m259.47,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m255.14,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m295.73,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m291.4,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m331.99,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m327.66,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.25,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m363.92,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m404.51,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m400.18,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m440.77,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m436.45,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.36,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.03,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.62,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.29,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m95.88,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.55,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.14,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.81,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m168.4,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m164.07,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m204.66,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.33,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m240.92,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m236.6,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m277.19,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m272.86,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m313.45,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m309.12,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m349.71,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m345.38,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m385.97,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m381.64,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m422.23,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m417.9,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m458.49,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m454.16,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.64,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.32,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.91,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.58,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.17,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.84,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.43,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.1,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m150.69,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m146.36,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.95,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m182.62,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.21,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.88,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m259.47,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m255.14,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m295.73,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m291.4,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m331.99,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m327.66,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.25,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m363.92,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m404.51,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m400.18,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m440.77,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m436.45,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.36,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.03,24c-5.86,0-10.63-4.77-10.63-10.63S13.17,2.74,19.03,2.74s10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.62,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.29,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m95.88,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.55,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.14,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.81,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m168.4,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m164.07,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m204.66,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.33,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m240.92,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m236.6,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m277.19,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m272.86,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m313.45,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m309.12,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m349.71,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m345.38,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m385.97,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m381.64,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m422.23,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m417.9,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m458.49,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m454.16,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.64,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.32,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.91,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.58,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.17,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.84,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.43,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.1,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m150.69,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m146.36,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.95,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m182.62,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.21,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.88,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m259.47,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m255.14,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m295.73,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m291.4,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m331.99,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m327.66,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.25,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m363.92,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m404.51,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m400.18,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m440.77,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m436.45,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.36,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.03,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.62,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.29,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m95.88,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.55,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.14,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.81,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m168.4,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m164.07,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m204.66,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.33,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m240.92,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m236.6,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m277.19,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m272.86,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m313.45,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m309.12,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m349.71,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m345.38,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m385.97,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m381.64,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m422.23,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m417.9,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m458.49,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m454.16,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.64,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.32,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.91,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.58,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.17,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.84,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.43,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.1,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m150.69,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m146.36,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.95,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m182.62,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.21,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.88,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m259.47,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m255.14,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m295.73,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m291.4,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m331.99,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m327.66,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.25,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m363.92,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m404.51,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m400.18,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m440.77,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m436.45,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.36,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.03,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m59.62,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m55.29,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m95.88,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.55,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m132.14,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.81,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m168.4,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m164.07,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m204.66,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.33,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m240.92,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m236.6,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m277.19,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m272.86,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m313.45,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m309.12,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m349.71,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m345.38,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m385.97,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m381.64,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m422.23,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m417.9,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m458.49,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m454.16,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.64,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.32,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.91,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.58,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m78.17,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.84,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m114.43,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m110.1,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m150.69,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m146.36,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.95,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m182.62,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.21,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.88,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m259.47,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m255.14,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m295.73,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m291.4,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m331.99,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m327.66,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.25,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m363.92,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m404.51,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m400.18,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m440.77,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m436.45,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m494.75,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m490.42,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m531.01,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m526.68,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m567.27,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m562.94,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m603.53,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m599.21,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m639.8,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m635.47,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m676.06,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m671.73,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m712.32,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m707.99,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m748.58,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m744.25,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m784.84,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m780.51,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m821.1,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m816.77,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m857.36,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m853.03,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m893.62,140.48c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m889.29,151.11c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m477.04,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m472.71,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m513.3,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m508.97,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m549.56,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m545.23,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m585.82,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m581.49,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m622.08,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m617.75,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m658.34,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m654.01,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m694.6,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m690.27,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m730.86,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m726.53,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m767.12,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m762.79,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m803.38,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m799.06,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m839.65,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m835.32,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m875.91,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m871.58,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m912.17,170.78c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m907.84,181.4c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m494.75,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m490.42,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m531.01,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m526.68,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m567.27,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m562.94,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m603.53,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m599.21,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m639.8,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m635.47,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m676.06,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m671.73,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m712.32,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m707.99,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m748.58,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m744.25,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m784.84,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m780.51,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m821.1,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m816.77,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m857.36,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m853.03,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m893.62,203.21c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m889.29,213.84c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m477.04,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m472.71,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m513.3,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m508.97,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m549.56,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m545.23,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m585.82,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m581.49,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m622.08,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m617.75,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m658.34,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m654.01,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m694.6,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m690.27,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m730.86,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m726.53,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m767.12,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m762.79,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m803.38,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m799.06,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m839.65,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m835.32,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m875.91,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m871.58,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m912.17,233.5c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m907.84,244.13c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m494.75,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m490.42,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m531.01,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m526.68,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m567.27,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m562.94,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m603.53,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m599.21,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m639.8,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m635.47,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m676.06,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m671.73,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m712.32,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m707.99,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m748.58,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m744.25,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m784.84,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m780.51,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m821.1,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m816.77,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m857.36,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m853.03,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m893.62,13.37c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m889.29,24c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m477.04,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m472.71,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m513.3,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m508.97,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m549.56,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m545.23,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m585.82,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m581.49,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m622.08,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m617.75,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m658.34,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m654.01,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m694.6,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m690.27,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m730.86,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m726.53,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m767.12,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m762.79,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m803.38,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m799.06,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m839.65,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m835.32,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m875.91,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m871.58,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m912.17,43.66c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m907.84,54.29c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m494.75,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m490.42,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m531.01,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m526.68,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m567.27,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m562.94,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m603.53,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m599.21,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m639.8,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m635.47,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m676.06,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m671.73,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m712.32,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m707.99,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m748.58,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m744.25,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m784.84,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m780.51,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m821.1,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m816.77,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m857.36,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m853.03,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m893.62,76.1c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m889.29,86.72c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m477.04,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m472.71,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m513.3,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m508.97,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m549.56,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m545.23,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m585.82,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m581.49,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m622.08,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m617.75,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m658.34,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m654.01,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m694.6,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m690.27,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m730.86,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m726.53,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m767.12,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m762.79,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m803.38,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m799.06,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m839.65,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m835.32,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m875.91,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m871.58,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m912.17,106.39c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m907.84,117.02c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m494.75,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m490.42,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m531.01,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m526.68,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m567.27,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m562.94,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m603.53,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m599.21,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m639.8,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m635.47,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m676.06,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m671.73,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m712.32,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m707.99,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m748.58,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m744.25,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m784.84,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m780.51,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m821.1,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m816.77,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m857.36,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m853.03,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m893.62,268.18c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m889.29,278.81c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m477.04,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m472.71,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m513.3,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m508.97,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m549.56,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m545.23,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m585.82,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m581.49,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m622.08,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m617.75,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m658.34,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m654.01,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m694.6,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m690.27,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m730.86,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m726.53,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m767.12,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m762.79,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m803.38,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m799.06,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m839.65,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m835.32,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m875.91,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m871.58,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m912.17,298.47c0,2.39-1.94,4.33-4.33,4.33s-4.33-1.94-4.33-4.33,1.94-4.33,4.33-4.33,4.33,1.94,4.33,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m907.84,309.1c-5.86,0-10.63-4.77-10.63-10.63s4.77-10.63,10.63-10.63,10.63,4.77,10.63,10.63-4.77,10.63-10.63,10.63Zm0-17.71c-3.91,0-7.09,3.18-7.09,7.09s3.18,7.08,7.09,7.08,7.09-3.18,7.09-7.08-3.18-7.09-7.09-7.09Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPw);
export default __webpack_public_path__ + "static/media/bg-pw.262d8ce99e94c845aff82b3227591070.svg";
export { ForwardRef as ReactComponent };